<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="任务编号：" >
                <el-input v-model.trim="searchForm.taskNo"  clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="searchFluxPollDetail(searchForm.taskNo)" clearable></el-input>
            </el-form-item>
            <el-form-item label="停机状态：">
                <el-select v-model="searchForm.stopedStatus" clearable>
                    <el-option label="停机成功" value="1"></el-option>
                    <el-option label="停机失败" value="2"></el-option>
                    <el-option label="流量充足" value="3"></el-option>
                    <el-option label="其 他" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchFluxPollDetail(searchForm.taskNo)" icon="el-icon-search">查 询</el-button>
                <el-button type="primary" @click="exportFluxPollDetailHandler()"  icon="el-icon-download">导 出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="detailTab.tableData" border  >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="ICCID" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" width="130"></el-table-column>
            <el-table-column label="总流量(G)" width="90">
                <template slot-scope="scope">
                    {{fluxMtoG(scope.row.flowData)}}
                </template>
            </el-table-column>

            <el-table-column label="已使用流量(G)" width="100">
                <template slot-scope="scope">
                    {{fluxMtoG(scope.row.usedFlowData)}}
                </template>
            </el-table-column>

            <el-table-column label="区间流量(G)" width="90">
                <template slot-scope="scope">
                    {{fluxMtoG(scope.row.syncFlowData)}}
                </template>
            </el-table-column>

            <el-table-column label="虚流量百分比" width="100">
                <template slot-scope="scope">
                    {{scope.row.flowRatePercent}} %
                </template>
            </el-table-column>

            <el-table-column label="已超流量(G)" width="90">
                <template slot-scope="scope">
                    {{scope.row.cllFlowData ? fluxMtoG(scope.row.cllFlowData) : 0}}
                </template>
            </el-table-column>
			
			<el-table-column label="是否已限速" width="90">
			    <template v-slot="scope">
			        {{scope.row.limitSpeed==true?'是':'否'}}
			    </template>
			</el-table-column>
            <el-table-column label="状态" width="90">
                <template slot-scope="scope">
                    {{scope.row.stopedStatus==1?'停机成功':scope.row.stopedStatus==2?'停机失败':'流量充足'}}
                </template>
            </el-table-column>

            <el-table-column prop="supplierSimStatusDes" label="运营商卡状态" width="100"></el-table-column>

            <el-table-column label="任务状态" width="90">
                <template slot-scope="scope">
                    {{scope.row.state ==0?'未核算':scope.row.state ==1?'已核算':''}}
                </template>
            </el-table-column>


            <el-table-column label="卡片类型" width="90">
                <template slot-scope="scope">
                    {{scope.row.type==2?'月卡':'30天卡'}}
                </template>
            </el-table-column>

            <el-table-column prop="stopedTime" label="轮询结束时间" width="150"></el-table-column>
            <el-table-column prop="failedMsg" label="备注" show-overflow-tooltip></el-table-column>
            

        </el-table>
        <el-pagination
            @size-change="detailTabHandleSizeChange"
            @current-change="detailTabHandleCurrentChange"
            :current-page="detailTab.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="detailTab.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="detailTab.total">
        </el-pagination>
    </div>
</template>
<script>
import {getFluxPollDetail, exportFluxPollDetail, } from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
             //详情
            searchForm:{
                taskNo:null,
                stopedStatus:null,
                iccid:null,
            },

            detailVisible: false,
            detailTab: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },


        }
    },
    methods: {
        searchFluxPollDetail(taskNo){
            this.searchForm.taskNo = taskNo;
            this.detailTab.currentPage = 1;
            this.getFluxPollDetailHandler();
        },

        getFluxPollDetailHandler($event){
            common.resetCurrentPage(this, $event, 'detailTab');
            var data = common.getRequestParams(this, 'detailTab', this.searchForm);
            getFluxPollDetail(data).then(res => {
                common.listCallback(this, res, 'detailTab');
            })
        },

        detailTabHandleSizeChange(val){
            this.detailTab.pageSize = val
            this.getFluxPollDetailHandler();
        },

        detailTabHandleCurrentChange(val){
            this.detailTab.currentPage = val;
            this.getFluxPollDetailHandler();
        },

        exportFluxPollDetailHandler(){
            let _that = this;
            common.deleteSpaceKey(_that.searchForm); 

            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                exportFluxPollDetail(_that.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(() => {

            });
        },


        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
    },
    created () {

    },

    mounted(){
        this.searchForm.taskNo = this.$store.state.menu.fluxPollDetailTaskNo;
        this.searchForm.iccid = this.$store.state.menu.fluxPollDetailIccid;
        this.getFluxPollDetailHandler();
    },

    computed:{
        fluxPollDetailSearch: function(){
            return this.$store.state.menu.fluxPollDetailTaskNo;
        },

        fluxPollDetailIccid: function(){
            return this.$store.state.menu.fluxPollDetailIccid;
        },
        
    },

    watch: {
        fluxPollDetailSearch: function(){
            this.searchForm.taskNo = this.$store.state.menu.fluxPollDetailTaskNo;
            this.getFluxPollDetailHandler();
        },

        fluxPollDetailIccid: function(){
            this.searchForm.iccid = this.$store.state.menu.fluxPollDetailIccid;
            this.getFluxPollDetailHandler();
        },
    },
}
</script>
<style lang="less" scoped>

</style>

